import {
  BrandConfigOptions,
  initializeBrandConfig,
} from '@cars4ever/brand-config-core';
import { ReactElement, useEffect } from 'react';

import GlobalConfig from '^common/GlobalConfig';
import { BRAND_CONFIG_URL } from '^configs/environments';

import RoutingRules from './RoutingRules';

const brandConfigOptions: BrandConfigOptions = {
  apiBaseUrl: BRAND_CONFIG_URL,
  preload: {
    brandWebsites: true,
  },
};

const App = (): ReactElement => {
  useEffect((): void => {
    void initializeBrandConfig(brandConfigOptions);
  }, []);

  return (
    <GlobalConfig>
      <RoutingRules />
    </GlobalConfig>
  );
};

export default App;
